import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AppointmentDetailsService } from '../../core/services/appointment-details.service';
import { WindowRefService } from '../../shared/window-ref.service';

/**
 * Guard to prevent the user from navigating back into the app once their appointment has been submitted.
 * It uses 'appointmentDetailsService.bookedAppointment' as the indication that the appointment has been submitted. When the
 * app is started, this value is null.
 * If an appointment has been submitted, this guard will simply reload the whole app.
 *
 * @param route
 * @param state
 */
export const appointmentSubmittedGuard: CanActivateFn = (route, state) => {
  const logger = inject(NGXLogger);
  const appointmentDetailsService = inject(AppointmentDetailsService);
  const windowRefService = inject(WindowRefService);

  logger.debug('appointmentSubmittedGuard: start', route, state);
  if (
    appointmentDetailsService.getBookedAppointment() ||
    appointmentDetailsService.appointmentRescheduled
  ) {
    logger.debug(
      'appointmentSubmittedGuard: appointment already submitted; reloading the app',
    );
    windowRefService.reload();
    return false;
  }

  return true;
};
